import type { SVGProps } from "react";
export interface PiggyBankIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PiggyBankIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PiggyBankIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m12 5.875.115.006a1.126 1.126 0 0 1 0 2.238L12 8.125H8a1.125 1.125 0 0 1 0-2.25zM.876 3.5a1.125 1.125 0 1 1 2.25 0c0 .483.392.874.875.875h.256l.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H4A3.125 3.125 0 0 1 .875 3.5Zm16.5 7a1.375 1.375 0 0 1-2.744.141l-.005-.14.005-.141A1.376 1.376 0 0 1 16 9.125l.141.008c.694.07 1.235.656 1.235 1.368Z"
      />
      <path
        fill={color}
        d="M3.125 11c0 1.832.612 3.38 1.364 4.662l.136.25c.305.596.5 1.275.5 1.997v1.966h2.024c.46-1.192 1.608-2 2.912-2h1.878a3.125 3.125 0 0 1 2.912 2h2.024v-1.532A4.125 4.125 0 0 1 20 14.341l.875-.22v-3.328A4.2 4.2 0 0 1 19.17 9.45l-.205-.299a41 41 0 0 0-.756-1.169 13 13 0 0 0-.453-.625l-.038-.046-.014-.014a1.13 1.13 0 0 1-.211-1.3l.886-1.775c-1.05-.202-2.123-.134-3.205.678a1.13 1.13 0 0 1-1.141.125c-2.44-1.11-5.204-.991-7.333.1C4.604 6.202 3.125 8.21 3.125 11m20 3.61c0 .746-.508 1.396-1.231 1.577l-1.35.337a1.875 1.875 0 0 0-1.419 1.819v2.158c0 .897-.728 1.624-1.625 1.624h-3.11a1.625 1.625 0 0 1-1.537-1.097l-.04-.133-.026-.107a.875.875 0 0 0-.848-.662h-1.878a.875.875 0 0 0-.848.662l-.026.107a1.626 1.626 0 0 1-1.578 1.23H4.5a1.626 1.626 0 0 1-1.625-1.624v-2.592c0-.269-.062-.55-.185-.83l-.144-.28C1.666 15.297.875 13.355.875 11c0-3.71 2.022-6.45 4.799-7.874 2.57-1.318 5.788-1.515 8.7-.394 2.294-1.39 4.543-.777 5.982-.298a1.127 1.127 0 0 1 .65 1.57l-1.183 2.365c.084.119.172.237.25.353.27.397.558.851.8 1.238l.098.142c.241.321.568.56.938.682l.105.036c.664.22 1.11.843 1.11 1.542v4.25Z"
      />
    </svg>
  );
}
